





























































































import {
  computed,
  defineComponent,
  PropType,
  useContext,
  useRouter,
} from "@nuxtjs/composition-api"

import UserAvatar from "@/components/UserAvatar.vue"
import useCurrency from "@/composables/useCurrency"
import { User } from "@/types/models/User"

export default defineComponent({
  components: { UserAvatar },
  props: {
    professional: {
      type: Object as PropType<User>,
      required: true,
    },
    specialities: {
      type: String,
      required: true,
    },
    languages: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const { formatCurrency } = useCurrency()
    const { app } = useContext()
    const router = useRouter()

    const location = computed(() => {
      return props.professional.professionalData?.distance
        ? (props.professional?.professionalData?.distance / 1000).toFixed(1) +
            app.i18n.t("professional.kmAway", app.i18n.locale)
        : undefined
    })

    const openProfessionalContact = () => {
      const path = app.$enums.AppPaths.PROFESSIONAL_CONTACT.replace(
        ":id",
        String(props.professional.professionalData?.shareLinkId),
      )
      router.push(app.localePath(path))
    }

    const hasSubscription = computed(() => {
      return !!props.professional.professionalData?.subscriptionData
    })

    const updateCurrentGeolocation = () => {
      emit("updateGeolocation")
    }

    return {
      location,
      formatCurrency,
      openProfessionalContact,
      hasSubscription,
      updateCurrentGeolocation,
    }
  },
})
